/**
 * Created by piotr.pozniak@thebeaverhead.com on 23/05/2024
 */

import React from "react";
import { getUploadResourceUrl } from "../../../../helpers/url";

/**
 * @param {Object} props
 * @param {Object} props.widget
 * @param {Boolean} [props.show=false]
 */
const Logo = ({ show = false, widget }) => {
  const orgSettings = widget.model?.organization?.settings;

  const orgLogo = getUploadResourceUrl(orgSettings?.logo);

  if (!show || !orgLogo) {
    return null;
  }

  return (
    <div className={"dc-calendar-branding--header-image-container"}>
      <img src={orgLogo} alt={"Logo"} />
    </div>
  );
};

export default Logo;
